"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgBoolCompact = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const use_t_1 = require("use-t");
const ContextItem_1 = require("../../ContextItem");
const Checkbox_1 = require("../../../../2-inline-block/Checkbox");
const OptionalBadge_1 = require("./OptionalBadge");
const DefaultableToggle_1 = require("./DefaultableToggle");
const autoWrapStyle = (hover) => ({
    display: 'inline-flex',
    alignItems: 'center',
    opacity: hover ? 1 : 0.5,
    transition: 'opacity .12s',
});
const readStructured = (v, fallback) => {
    if (v && typeof v === 'object' && 'def' in v) {
        const s = v;
        return { def: !!s.def, value: !!s.value };
    }
    return { def: false, value: typeof v === 'boolean' ? v : fallback };
};
const ArgBoolCompact = ({ param, value, onChange }) => {
    const [t] = (0, use_t_1.useT)();
    const [hover, setHover] = React.useState(false);
    const label = param.display?.() ?? t(param.name ?? param.id ?? '');
    const defaultable = !!param.defaultable;
    const fallback = !!param.default;
    const s = readStructured(value, fallback);
    const def = defaultable && s.def;
    const emit = (next) => {
        if (defaultable)
            onChange(next);
        else
            onChange(next.value);
    };
    const toggleValue = () => emit({ def: false, value: !s.value });
    const enterCustom = () => emit({ def: false, value: s.value });
    const revertToAuto = () => emit({ def: true, value: s.value });
    const checkbox = (on) => (React.createElement("span", { style: { display: 'inline-flex', margin: '-5px 0' } },
        React.createElement(Checkbox_1.Checkbox, { as: "div", small: true, on: on })));
    const right = defaultable ? (React.createElement("span", { style: { display: 'inline-flex', alignItems: 'center', gap: 4, marginRight: -8 } }, def ? (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: true, onClick: enterCustom }),
        React.createElement("span", { style: autoWrapStyle(hover), onMouseEnter: () => setHover(true), onMouseLeave: () => setHover(false) }, checkbox(fallback)))) : (React.createElement(React.Fragment, null,
        React.createElement(DefaultableToggle_1.DefaultableToggle, { def: false, onClick: revertToAuto }),
        checkbox(s.value))))) : (checkbox(s.value));
    return (React.createElement(ContextItem_1.ContextItem, { icon: param.icon?.(), control: true, inset: true, onClick: defaultable && def ? enterCustom : toggleValue, style: { paddingTop: 8, paddingBottom: 8 }, right: right },
        React.createElement("span", null,
            label,
            param.optional && React.createElement(OptionalBadge_1.OptionalBadge, null))));
};
exports.ArgBoolCompact = ArgBoolCompact;
